import { ComposerKeyType } from '../../keys';

const composer: ComposerKeyType = {
  singular: 'Композитор',
  composeButton: 'Компоновать',
  composeModalTitle: 'Компоновка сцены',
  loading: 'Загрузка композитора…',
  studioRender: 'Рендер',
  aiImageryTool: 'ИИ-инструмент изображений',
  comingSoon: 'Скоро будет доступно',
  renderRequested: 'Запрос на рендер добавлен в очередь',
  renderRequestFailed: 'Не удалось запросить рендер',
  requestRender: 'Запросить рендер',
  generatingRender: 'Генерация рендера…',
  generatingRenderMessage: 'Рендерим вашу сцену — это займёт около минуты.',
  createdRenders: 'Рендеры',
  backToScene: 'Назад к сцене',
  generationModeCompositeRender: 'композитный рендер',
  generationModeLifestyle: 'лайфстайл',
  generatingLifestyle: 'Генерация лайфстайла…',
  generatingLifestyleMessage:
    'Генерируем лайфстайл-изображение — это займёт около минуты.',
  lifestylePromptPlaceholder: 'Опишите сцену для генерации из этого рендера...',
  addReferences: 'Добавить референсы',
  renderCancelled: 'Рендер остановлен',
  backgroundDefault: 'По умолчанию',
  backgroundBlack: 'Чёрный',
  backgroundWhite: 'Белый',
  backgroundGray: 'Серый',
  backgroundCustom: 'Свой цвет',
  backgroundColorPicker: 'Выбор цвета',
  productsLibrary: 'Библиотека продуктов',
  productsLibraryHint: '— перетащите продукты в сцену, чтобы разместить их',
  releaseToPlace: 'Отпустите, чтобы разместить в сцене',
  noProductsFound: 'Продукты не найдены',
  composeDisabledMissingModel:
    'У одного или нескольких выбранных продуктов нет 3D-модели',
  productLoadFailed: 'Не удалось загрузить «{{productName}}» в сцену'
};

export default composer;
